module.exports = __webpack_public_path__ + "spring_logo-spring.4ffd8b.svg";